import { Device, DeviceInfoDefaults } from '../deviceInfoTypes';

export function getDevice(ua: NavigatorID['userAgent']): Device {
  const device = {
    ...DeviceInfoDefaults.device,
    IS_IPHONE: /iPhone/.test(ua),
  };

  return device;
}
